import React from 'react';
import Modal from '../ui/Modal';
import { PREDEFINED_SECTIONS } from '../../constants/plansConstants';

const PlanSectionEditor = ({ 
  activeSection, 
  activePlan,
  fieldValue,
  saving,
  aiLoading,
  guide,
  usageLimits,
  onTextChange, 
  onSave, 
  onSuggest,
  onShowGuide,
  onCloseGuide
}) => {
  const isPredefined = PREDEFINED_SECTIONS.has(activeSection);

  const getRemainingForSection = () => {
    if (isPredefined) return Infinity;
    if (!usageLimits) return 2;
    const used = usageLimits.suggestions?.by_section?.[activeSection] || 0;
    const max = usageLimits.suggestions?.max_per_section || 2;
    return Math.max(0, max - used);
  };

  const remaining = getRemainingForSection();
  const isLimitReached = !isPredefined && remaining === 0;

  const getSuggestButtonLabel = () => {
    if (aiLoading) return isPredefined ? 'Cargando...' : 'Generando...';
    if (isPredefined) return 'Recomendaciones BMC';
    return `Sugerencias IA (${remaining}/2)`;
  };

  return (
    <section style={{ flex: 1, minWidth: 0 }}>
      <h2 className="section-title">{activeSection}</h2>
      <div className="actions-bar" style={{ justifyContent: 'flex-end' }}>
        <button 
          className="icon-btn" 
          aria-label="Ver guía de este campo" 
          title="Guía de este campo" 
          onClick={onShowGuide}
        >
          i
        </button>
      </div>
      <textarea
        rows={12}
        className="editor-textarea"
        value={fieldValue}
        onChange={onTextChange}
      />
      <div className="actions-bar">
        <button 
          className="primary-btn" 
          disabled={saving} 
          onClick={onSave}
        >
          {saving ? 'Guardando...' : 'Guardar'}
        </button>
        <button 
          className={isPredefined ? 'secondary-btn predefined-btn' : 'secondary-btn'}
          onClick={onSuggest} 
          disabled={aiLoading || isLimitReached}
          title={
            isLimitReached
              ? 'Has alcanzado el límite de sugerencias para esta sección hoy'
              : isPredefined
                ? 'Recomendaciones basadas en la teoría del Business Model Canvas'
                : ''
          }
        >
          {getSuggestButtonLabel()}
        </button>
      </div>
      
      {isLimitReached && (
        <div className="limit-warning">
          <span className="limit-icon">⏰</span>
          Has alcanzado el límite de 2 sugerencias para esta sección hoy. Vuelve mañana.
        </div>
      )}
      
      {!isPredefined && !isLimitReached && remaining < 2 && (
        <div className="usage-info">
          <span className="usage-info-icon">ℹ️</span>
          Te quedan {remaining} {remaining === 1 ? 'sugerencia' : 'sugerencias'} para esta sección hoy.
        </div>
      )}

      <Modal 
        open={!!guide} 
        title={guide ? `Guía de campo: ${guide.section}` : ''} 
        onClose={onCloseGuide}
      >
        {guide?.quick_tips?.length > 0 && (
          <>
            <h4>Tips rápidos</h4>
            <ul>
              {guide.quick_tips.map((t, i) => (<li key={i}>{t}</li>))}
            </ul>
          </>
        )}
        {guide?.improvement_ideas?.length > 0 && (
          <>
            <h4>Ideas de mejora</h4>
            <ul>
              {guide.improvement_ideas.map((t, i) => (<li key={i}>{t}</li>))}
            </ul>
          </>
        )}
      </Modal>
    </section>
  );
};

export default PlanSectionEditor;
